import React from 'react';
import { CircularProgress, Stack, StackProps, styled } from '@mui/material';

interface MuiLoaderProps extends StackProps {
    absolute?: boolean | undefined;
    loading: boolean;
    size?: number | string;
}

const StyledLoaderContainer = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: theme.zIndex.modal,
}));
const FlexContainer = styled(Stack)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
}));
const Backdrop = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
    zIndex: theme.zIndex.modal - 1,
}));

const MuiLoader: React.FC<MuiLoaderProps> = ({ absolute, loading = false, size, ...props }) => {
    if (!loading) {
        return null;
    }

    if (absolute) {
        return (
            <>
                <Backdrop />
                <StyledLoaderContainer>
                    <CircularProgress size={size} color="warning" />
                </StyledLoaderContainer>
            </>
        );
    }

    return (
        <FlexContainer {...props}>
            <CircularProgress size={size} color="warning" />
        </FlexContainer>
    );
};

export default MuiLoader;
